
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/part-identification",
      function () {
        return require("private-next-pages/part-identification.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/part-identification"])
      });
    }
  